import React from "react";
import Header from './Header';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import newOrder from '../sounds/new_notice.mp3';

import {
    loadAuth as loadAuthAction,
    loseAuth as loseAuthAction
} from '../actions/auth';

import { clearPendingOrdersCount, getPendingOrdersCount } from '../actions/orders';
import { clearCalback, fetchCallbackEnquiry } from "../actions/callback";

import * as permissions from '../constants/permissions';

let Wrapper = class extends React.Component {

    constructor(props) {
        super(props);

        this.logOut = this.logOut.bind(this);
        this.state = { newOrderAudio: new Audio(newOrder) }
    }

    componentWillMount() {
        if (!this.props.auth.user) {
            this.props.loadAuthAction();
        }
    }

    logOut() {
        this.props.loseAuthAction();
        this.props.clearPendingOrdersCount();
        this.props.clearCalback();
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.auth.user && !sessionStorage.getItem('man-token')) {
            this.props.push('/login');
        }
    }

    render() {
        const { component: Component, auth, callbacks, childProps, orders, showHeader } = this.props;
        const user = auth.get('user');
        const callbackEnquiriesLength = callbacks.enquiries.length;
        const pendingOrdersCount = orders.get('pendingOrdersCount');

        const cachedOrdersCount = sessionStorage.getItem('pendingOrdersCount');
        const cachedCallbacksCount = sessionStorage.getItem('cachedCallbacksCount');

        const needUpdateOrdersCountCache = user && user.Role != permissions.RECEPTION_POINT && cachedOrdersCount == null;
        const needUpdateCallbacksCountCache = user && user.Role != permissions.RECEPTION_POINT && cachedCallbacksCount == null;
        const needAlert = (cachedOrdersCount != null && cachedOrdersCount < pendingOrdersCount) || (cachedCallbacksCount != null && cachedCallbacksCount < callbackEnquiriesLength);

        if (needUpdateOrdersCountCache)
            this.props.getPendingOrdersCount();
        if (needUpdateCallbacksCountCache)
            this.props.fetchCallbackEnquiry();
        if (needAlert){
            this.state.newOrderAudio.play().then(_ => {}).catch(error => {});
        }
        sessionStorage.setItem('pendingOrdersCount', pendingOrdersCount);
        sessionStorage.setItem('cachedCallbacksCount', callbackEnquiriesLength);
        return (
            <div>
                {showHeader && <Header user={user} logOut={this.logOut} callbackEnquiriesLength={callbackEnquiriesLength} pendingOrdersCount={pendingOrdersCount} />}
                <Component {...childProps} />
            </div>
        );
    }
}

Wrapper = connect((state, props) => ({
    auth: state.application.get('auth'),
    callbacks: state.application.get('callbacks'),
    childProps: props,
    orders: state.application.get('orders'),
}), { loadAuthAction, 
    loseAuthAction, 
    clearPendingOrdersCount, 
    getPendingOrdersCount, 
    clearCalback,
    fetchCallbackEnquiry,
    push })(Wrapper);

Wrapper.defaultProps = {
    showHeader: true
}

export default Wrapper;


// WEBPACK FOOTER //
// ./src/components/Wrapper.jsx